import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-school-imports',
    templateUrl: './school-imports.component.html',
    styleUrls: ['./school-imports.component.scss'],
})
export class SchoolImportsComponent {
    @Output() public elementSizeModification = new EventEmitter<void>();
}
